import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const RegularidadAporte = ({ regularidad, detalleAporte }) => {
    if (!regularidad) {
        return (
            <div className="card shadow-sm border-0 rounded-4 p-4 mt-4 h-100">
                <h5 className="fw-bold mb-3" style={{ color: "#6c757d" }}>
                    Regularidad de Aportes RTI
                </h5>
                <div className="alert alert-secondary text-center">
                    No hay datos de regularidad para mostrar.
                </div>
            </div>
        );
    }

    const {
        cumpleRegularidad,
        viaDeCumplimiento,
        puedePerderla,
        fechaProximoCambio,
        proximaViaDeCumplimiento,
        aporteCriticoFecha,
        mensaje,
        mesesEnUltimos36, // Nuevo
        mesesEnUltimos60, // Nuevo
        mesesTotales      // Nuevo
    } = regularidad;

    const formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        const [year, month, day] = fecha.split('-');
        return `${day}/${month}/${year}`;
    };

    const getStatusInfo = () => {
        if (cumpleRegularidad) {
            if (puedePerderla) {
                return {
                    icon: <WarningAmberIcon className="me-2" style={{ color: '#ffc107' }} />,
                    badgeClass: 'bg-warning text-dark',
                    text: 'CUMPLE (EN RIESGO)',
                    borderColor: 'border-warning'
                };
            }
            return {
                icon: <CheckCircleIcon className="me-2 text-success" />,
                badgeClass: 'bg-success',
                text: 'CUMPLE',
                borderColor: 'border-success'
            };
        }
        return {
            icon: <CancelIcon className="me-2 text-danger" />,
            badgeClass: 'bg-danger',
            text: 'NO CUMPLE',
            borderColor: 'border-danger'
        };
    };

    const status = getStatusInfo();

    const renderDetalleRiesgo = () => {
        if (!puedePerderla) return null;

        const esPerdidaTotal = proximaViaDeCumplimiento === 'No cumple';

        return (
            <div className={`alert mt-2 p-2 ${mensaje.includes('Urgente') ? 'alert-danger' : 'alert-warning'}`}>
                <p className="mb-1">
                    {esPerdidaTotal ? (
                        <>
                            <EventBusyIcon fontSize="small" className="me-1" />
                            <strong>Fecha de pérdida de regularidad:</strong> {formatearFecha(fechaProximoCambio)}
                        </>
                    ) : (
                        <>
                            <TrendingDownIcon fontSize="small" className="me-1" />
                            <strong>Próximo cambio de condición:</strong> {formatearFecha(fechaProximoCambio)}
                        </>
                    )}
                </p>
                {aporteCriticoFecha && (
                    <p className="mb-1 small">
                        El cambio se producirá por el vencimiento del aporte de <strong>{formatearFecha(aporteCriticoFecha).substring(3)}</strong>.
                    </p>
                )}
                {!esPerdidaTotal && (
                    <p className="mb-0 small">
                        Pasará a la condición: <strong>{proximaViaDeCumplimiento}</strong>.
                    </p>
                )}
            </div>
        );
    };

    return (
        <div className={`card shadow-lg border-2 rounded-4 p-4 mt-4 h-100 ${status.borderColor}`}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0" style={{ color: "#6c757d" }}>
                    Regularidad de Aportes
                </h5>
                <span className={`badge rounded-pill px-3 py-2 ${status.badgeClass}`}>
                    {status.text}
                </span>
            </div>

            <div className="d-flex align-items-center mb-3">
                {status.icon}
                <p className="mb-0 fw-semibold">{mensaje}</p>
            </div>

            {cumpleRegularidad && (
                <p>
                    <strong>Vía de cumplimiento actual:</strong> {viaDeCumplimiento || 'No especificada'}
                </p>
            )}

            {renderDetalleRiesgo()}

            {!cumpleRegularidad && (
                <div className="alert alert-light mt-3 p-3 border rounded-3 bg-light">
                    <h6 className="fw-bold mb-2 text-secondary">
                        <InfoOutlinedIcon fontSize="small" className="me-1" />
                        Diagnóstico de aportes:
                    </h6>
                    <ul className="mb-0 small ps-3 text-muted">
                        <li className="mb-1">
                            Aportes ultimos 36 meses: <strong>{mesesEnUltimos36 || 0}</strong>
                            <span className="ms-1 fst-italic">(Mínimo requerido: 18)</span>
                        </li>
                        <li className="mb-1">
                            Aportes últimos 60 meses: <strong>{mesesEnUltimos60 || 0}</strong>
                            <span className="ms-1 fst-italic">(Para vía alternativa 1 de 5)</span>
                        </li>
                        <li>
                            Total aportes históricos: <strong>{mesesTotales || 0}</strong>
                            <span className="ms-1 fst-italic">(Minimo 15 años: 180 meses)</span>
                        </li>
                    </ul>
                </div>
            )}

            {/* Sección de Detalle de Aporte (Nuevo) */}
            {detalleAporte && (
                <div className="mt-3 p-3 rounded-3" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #6c757d" }}>
                    <div className="d-flex align-items-center mb-1">
                        <InfoOutlinedIcon fontSize="small" className="me-2 text-secondary" />
                        <strong className="text-secondary">Observación de Aportes:</strong>
                    </div>
                    <p className="mb-0 text-dark small">{detalleAporte}</p>
                </div>
            )}
        </div>
    );
};

export default RegularidadAporte;
